import { Component, Input, OnChanges, OnInit, SimpleChange } from '@angular/core';

import { ApiBlockSettings } from 'apps/arsultima/src/app/models/settings.model';
import { IMAGES_FILENAME_PREFIX } from 'apps/arsultima/src/app/models/image.model';
import { ImageService } from './../../../../services/image.service';
import { NavigateService } from './../../../../core/authentication/services/navigate/navigate.service';
import { Pages } from 'apps/arsultima/src/app/models/pages.enum';
import { URL_ROUTER } from '../../../../utils/url-router';
import { Utils } from './../../../../utils/utils';

@Component({
  selector: 'arsultima-block',
  templateUrl: './block.component.html',
  styleUrls: ['./block.component.scss'],
})
export class BlockComponent implements OnInit, OnChanges {
  @Input()
  block: ApiBlockSettings;

  @Input()
  id: string;

  @Input()
  page: Pages;

  @Input()
  isEditable: boolean;

  private _imageUrl: string;

  constructor(private navigateService: NavigateService, private imageService: ImageService) {}

  ngOnInit(): void {}

  ngOnChanges(changes: { [key: string]: SimpleChange }) {
    const { block } = changes;
    if (block && block.currentValue) {
      this.imageUrl = this.imageService.getImageUrl(this.block.ID, { prefix: IMAGES_FILENAME_PREFIX.blocks });

      if (this.block.nom_pic) {
        this.imageUrl = this.imageService.getImageUrl(this.block.ID, { prefix: IMAGES_FILENAME_PREFIX.blocks });
      }
    }
  }

  set imageUrl(url: string) {
    this._imageUrl = Utils.addRefreshParamToImage(url);
  }

  get imageUrl(): string {
    return this._imageUrl;
  }

  editBlock() {
    this.navigateService.navigate(URL_ROUTER.blockEdit(this.block.ID), {
      queryParams: { page: this.page },
    });
  }
}
